import React, { Component } from 'react';
import {connect} from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from "@avalara/skylab-sdk/react";

const log = new Logger('BULK_REPLACE_NODE_SELECTOR', LOG_LEVELS.DEBUG);

class NodeSelector extends Component {

    constructor(props) {
        super(props);
        // Initialize with selected prop (default 0) or first item
        const initialIndex = (props.selected !== undefined && props.selected !== null) 
            ? props.selected 
            : 0;
        this.state = { selectedIndex: initialIndex };
    }

    onChange(event) {
        log.debug("onChange(): event: ", event);
        // Guard: Skylab SSelect fires event on click outside with undefined item
        const selectedValue = event?.detail?.item?.value;
        if (selectedValue === undefined || selectedValue === null) {
            return;
        }
        
        // Find the index of selected node in the list
        const selectedIndex = this.props.list.findIndex(node => node === selectedValue);
        if (selectedIndex === -1) {
            return; // Invalid selection
        }
        
        // Skip if same index selected (prevents unnecessary updates)
        if (selectedIndex === this.state.selectedIndex) {
            return;
        }
        
        this.setState({ selectedIndex });
        
        // Pass back both index and value to parent (BulkReplacePanel expects index)
        this.props.onChange && this.props.onChange({
            index: selectedIndex,
            value: selectedValue,
            displayString: selectedValue
        });
    }

    getNodeOptions() {
        const list = this.props.list || [];
        return list.map((node, index) => ({
            label: node,
            value: node,
            selected: this.state.selectedIndex === index
        }));
    }
    
    // Get current selected node value for defaultValue
    getSelectedValue() {
        const list = this.props.list || [];
        const index = this.state.selectedIndex;
        if (index >= 0 && index < list.length) {
            return list[index];
        }
        return '';
    }

    render () {
        return (
            <div>
                <label>Select node</label>
                <SSelect 
                    defaultValue={this.getSelectedValue()}
                    inputId="single-node-select"
                    name="node"
                    onS-select={this.onChange.bind(this)}
                    optionsList={this.getNodeOptions()}
                    multiple={false}
                    showSelectionCount={false}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const stateProps = {
        languages: state.languages
    };
    return stateProps;
}

function mapDispatchToProps(dispatch) {

    const dispatchProps = {
    };
    return dispatchProps;
}


NodeSelector.defaultProps = {
    selected: 0,
    onChange: () => {}
};

export default connect(mapStateToProps, mapDispatchToProps)(NodeSelector);